import { GlobalHealthSystem } from "../healthSystem/global-health-system";
import { Practitioner } from "./practitioner";

export class PhysicianPractice extends Practitioner {
  healthSystems: GlobalHealthSystem[] = [];
}
